import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-md-row gap-3 mb-3" }
const _hoisted_2 = { class: "flex-fill w-100 d-flex flex-column" }
const _hoisted_3 = { class: "mt-3 p-2" }
const _hoisted_4 = { class: "flex-fill w-100 d-flex flex-column" }
const _hoisted_5 = { class: "mt-3 p-2" }
const _hoisted_6 = { class: "flex-fill w-100 d-flex flex-column" }
const _hoisted_7 = { class: "mt-3 p-2" }

import SubSection from '../common/SubSection.vue';

type OptionType = 'DIY' | 'Guidance' | 'Advice';


export default /*@__PURE__*/_defineComponent({
  __name: 'ManagementChoices',
  emits: ["detail-requested"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

function handleClick(option: OptionType) {
  window.scrollTo({ top: 0, behavior: 'auto' });
  emit('detail-requested', option);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SubSection, {
    title: "Do it yourself, guidance, or advice?",
    showHelp: false
  }, {
    default: _withCtx(() => [
      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mb-3" }, " You can choose to do things yourself, get advice or use a guidance based option. ", -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header p-2 text-center" }, "Do it yourself", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-grow-1 description p-3" }, [
            _createElementVNode("p", null, "Use a DIY provider and manage your plan payments yourself."),
            _createElementVNode("p", null, "Offers a very wide range of funds and investment options to construct an investment portfolio yourself."),
            _createElementVNode("p", { class: "fw-bold" }, "Offered by many pension providers in the market."),
            _createElementVNode("p", null, "Examples shown if you click 'Do it Yourself' below.")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-option w-100",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick('DIY')))
            }, "Do it yourself")
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "header p-2 text-center" }, "Guidance based", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-grow-1 description p-3" }, [
            _createElementVNode("p", null, "Use a provider to put your plan payments in place with on an automated basis with a simple, limited range of funds for you to choose from."),
            _createElementVNode("p", null, "Receive the monthly plan payments as wanted with the ability for you to check and review the progress of your plan yourself over time."),
            _createElementVNode("p", { class: "fw-bold" }, "Offered by Pathlines with support from Guiide"),
            _createElementVNode("p", null, "More info shown if you click Guidance below.")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-option w-100",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClick('Guidance')))
            }, "Guidance")
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "header p-2 text-center" }, "Get advice", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-grow-1 description p-3" }, [
            _createElementVNode("p", null, "Take your plan to an adviser to recommend a suitable provider and investments."),
            _createElementVNode("p", null, "Needed if you want a clear recommendation on a provider to choose, or which investment strategy is suitable for you. Can also include annual advice reviews if wanted."),
            _createElementVNode("p", { class: "fw-bold" }, "Offered by many advisers in the market."),
            _createElementVNode("p", null, "Examples shown if you click Advice below.")
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-option w-100",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (handleClick('Advice')))
            }, "Advice")
          ])
        ])
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mt-5 fw-bold" }, " Commercial disclosures ", -1)),
      _cache[11] || (_cache[11] = _createElementVNode("p", null, "If you choose the DIY provider route - Guiide receives no payments from any DIY provider shown. Guiide does have some commercial licensing relationships with some providers shown.", -1)),
      _cache[12] || (_cache[12] = _createElementVNode("p", null, "If you choose the Guidance based route - Guiide will receive ongoing payments from Pathlines. These are paid to Guiide from the Pathlines product fee. Given the integration with Guiide plan payments, this product is only available via Guiide.", -1)),
      _cache[13] || (_cache[13] = _createElementVNode("p", null, "If you choose Advice - Guiide may receive one off referral fees from any adviser shown.", -1)),
      _cache[14] || (_cache[14] = _createElementVNode("p", null, "There are a wide range of alternative providers and advisers on the market. You can use your Guiide plan with any provider or adviser you choose. There is no restriction on doing this and our modelling tools remain available to everyone.", -1))
    ]),
    _: 1
  }))
}
}

})